class AnnouncementBar extends HTMLElement {
    constructor() {
        super();

        this.heightPropertyName = "--enjp-announceBar-height";
        this.setHeightVariable = this.setHeightVariable.bind(this);
    }

    connectedCallback() {
        this.setHeightVariable();
        window.addEventListener("resize", this.setHeightVariable);
    }

    disconnectedCallback() {
        window.removeEventListener("resize", this.setHeightVariable);
    }

    setHeightVariable() {
        const newHeight = `${this.offsetHeight}px`;
        document.documentElement.style.setProperty(this.heightPropertyName, newHeight);
    }
}

if (!customElements.get('announcement-bar')) {
    customElements.define('announcement-bar', AnnouncementBar);
}

class StickyHeader extends HTMLElement {
    constructor() {
        super();
        this.DEV = false;
        this.heightPropertyName = "--custom-header-height";

        // riferimenti per mega menu
        this.banner = document.getElementById('custom-mega-banner');
        this.overlay = document.getElementById('page-blur-overlay');
    }

    connectedCallback() {
        this.header = this.querySelector('.header');
        if (!this.header) return;

        this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always'
            || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
        this.headerBounds = {};

        this.setHeaderHeight();

        if (window.matchMedia('(max-width: 767px)').matches) {
            setTimeout(() => {
                const expectedHeight = `${this.header.offsetHeight}px`;
                const currentCSSHeight = getComputedStyle(document.documentElement)
                    .getPropertyValue(this.heightPropertyName)
                    .trim();

                if (currentCSSHeight !== expectedHeight) {
                    this.setHeaderHeight();
                }
            }, 1000);
        }
        window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this, null));

        if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
        }

        this.currentScrollTop = 0;
        this.preventReveal = false;
        this.predictiveSearch = this.querySelector('predictive-search');

        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => this.preventReveal = true;

        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);

        this.createObserver();

    }

    disconnectedCallback() {
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.removeEventListener('scroll', this.onScrollHandler);
    }
    setHeaderHeight(height = null) {
        const newHeight = height || `${this.offsetHeight}px`;
        document.documentElement.style.setProperty(this.heightPropertyName, newHeight);
    }

    createObserver() {
        let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
        });
        observer.observe(this.header);
    }

    onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            if (this.preventHide) return;
            requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            if (!this.preventReveal) {
                requestAnimationFrame(this.reveal.bind(this));
            } else {
                window.clearTimeout(this.isScrolling);
                this.isScrolling = setTimeout(() => {
                    this.preventReveal = false;
                }, 66);
                requestAnimationFrame(this.hide.bind(this));
            }
        } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
        }

        this.currentScrollTop = scrollTop;
    }

    hide() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
        this.closeMenuDisclosure();
    }

    reveal() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
        this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
        this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
        this.searchModal = this.searchModal || this.header.querySelector('details-modal');
        if (this.searchModal) this.searchModal.close(false);
    }
}
if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
}

class LogoMorpher extends HTMLElement {
    constructor() {
        super();
        this.logoWrapper = this.querySelector('.logo-wrapper svg');
        this.threshold   = 50; // Scroll height before the change
        this.onScroll    = this.onScroll.bind(this);
    }

    connectedCallback() {
        window.addEventListener('scroll', this.onScroll);
    }

    disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
    }

    onScroll() {
        window.requestAnimationFrame(() => {
            if (window.scrollY > this.threshold) {
                this.logoWrapper.setAttribute("short", "");
            } else {
                this.logoWrapper.removeAttribute("short");
            }
        });
    }
}
if (!customElements.get('logo-morpher')) {
    customElements.define('logo-morpher', LogoMorpher);
}

class EnjpMenuIcon extends HTMLElement {
    constructor(){
        super();
        this.customerId = this.dataset.customerId;
        this.wishlistData = {};
    }

    connectedCallback() {
        window.addEventListener('DOMContentLoaded', () => {
            this.loadWishlist();
        });
        subscribe(PUB_SUB_EVENTS.wishlistUpdated, () =>
            this.loadWishlist());

    }

    getWishlistId() {
        var cookies = decodeURIComponent(document.cookie).split(';');

        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i].trim();

            if (cookie.indexOf('wishlist_id=') === 0) {
                return cookie.substring('wishlist_id='.length);
            }
        }

        return null;
    }

    loadWishlist() {
        let urlToFetch;
        if (this.customerId) {
            urlToFetch = '/a/wishlist?type=api&customerid=' + this.customerId + '&version=1';
        } else {
            urlToFetch = '/a/wishlist?type=api&wishlistid=' + this.getWishlistId() + '&version=1';
        }

        fetch(urlToFetch).
        then(response => response.text()).
        then(
            (data) => {
                this.wishlistData = JSON.parse(data);
                this.updateWishlistIcon();
            }
        ).catch(err => console.log('Error while fetching wishlist:', err));
    }

    updateWishlistIcon(){
        if( this.wishlistData.count > 0 )
            this.classList.add("js-enjp-wishlist");
        else{
            this.classList.remove("js-enjp-wishlist");
        }
    }
}

if (!customElements.get('enjp-wishlist-icon')) {
    customElements.define('enjp-wishlist-icon', EnjpMenuIcon);
}

class EnjpHeader extends HTMLElement {
    constructor() {
        super();
        this.hasHeroMedia = false;
    }

    connectedCallback() {
        this.readHeroMedia();
        // attacca handler
        window.addEventListener('scroll', () => this.updateOnScroll());

        // prima esecuzione
        this.updateOnScroll();
    }


    readHeroMedia() {
        const dataEl = document.getElementById('hero-media-data');
        if (!dataEl) return;

        try {
            const data = JSON.parse(dataEl.textContent);
            this.hasHeroMedia = !!data.media;
        } catch (e) {
            console.warn('Invalid hero media data', e);
        }
    }

    updateOnScroll() {
        if (window.scrollY > 0) {
            this.classList.add('scrolled');
        } else {
            if (!this.hasHeroMedia) {
                // se non c'è media, sempre scrolled
                this.classList.add('scrolled');
            } else {
                // altrimenti togli scrolled
                this.classList.remove('scrolled');
            }
        }
    }
}

if (!customElements.get('enjp-header')) {
    customElements.define('enjp-header', EnjpHeader);
}

class ProductCard extends HTMLElement {
    constructor() {
        super();
        this.quickAddGrid = this.querySelector('quick-add');
        this.quickAddTitle = this.querySelector('[data-quick-add-title]');
        this.cart = document.querySelector('cart-items') || document.querySelector('cart-drawer');
        this.quickAddBtns      = this.querySelectorAll('[data-quick-add]');


        /* WISHLIST */
        this.wishlistInput    = this.querySelector('[data-js="wishlist"]');
    }

    connectedCallback() {
        this.productJson = this.createJSONFromAttributes(this);
        this.quickAddBtns.forEach((btn) => {
            btn.addEventListener("click", (e) => this.onQuickAddClick(e, btn));
        });
        this.addEventListener("mouseleave", () => {
            this.resetErrors();
        });
    }

    async onQuickAddClick(event, btn) {
        event.preventDefault();

        const variantId = btn.dataset.variantId;
        if (!variantId) {
            return;
        }
        this.toggleLoading(true, btn);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = { items: [ {
                id: variantId,
                quantity: 1,
                properties: {
                    _quickAdd: true
                }
            }], sections_url: window.location.pathname, sections: this.cart.getSectionsToRender().map((section) => section.id) };
        config.body = JSON.stringify(formData);
        config.headers = {
            'Content-Type': 'application/json',
            ...config.headers
        };

        const fetchResponse = await fetch(`${routes.cart_add_url}`, config);
        const response = await fetchResponse.json();
        this.toggleLoading(false, btn);

        if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.items[0]?.id,
                errors: response.errors || response.description,
                message: response.message,
            });
            this.handleCardErrorMessage(response.description);
        }

        if (!this.error) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.items[0]?.id,
                cartData: response,
            });
        }
        this.error = false;
        this.cart.onCartUpdate ? this.cart.onCartUpdate() : this.cart.renderContents(response);
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');

        if (window.template.name === 'cart') {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }

    resetErrors(errorMessage = false){
        this.errorMessageWrapper =
            this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        this.quickAddTitle.classList.remove('tw-hidden');
    }

    handleCardErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
            this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        this.quickAddTitle.classList.add('tw-hidden');

        if (errorMessage) {
            this.errorMessage.textContent = errorMessage;
        }
    }

    toggleLoading(show, btn) {
        if (show) {
            this.quickAddGrid.classList.add('!tw-opacity-100');
            btn.setAttribute("data-checked", "");
            btn.querySelector('[data-add-to-cart-label]').classList.add('tw-hidden');
            btn.querySelector('.loading__spinner').classList.remove('hidden');
        }
        else{
            this.quickAddGrid.classList.remove('!tw-opacity-100');
            btn.removeAttribute("data-checked");
            btn.querySelector('[data-add-to-cart-label]').classList.remove('tw-hidden');
            btn.querySelector('.loading__spinner').classList.add('hidden');
        }
    }

    createJSONFromAttributes(element) {
        const json = JSON.parse(element.querySelector('[data-product-json]').textContent);
        return {
            ...json,
            url               : element.dataset.productUrl?.split('?')[0],   // Remove req params from url
            handle            : json?.url || json?.handle,
            title             : element.dataset.productTitle,
            price             : element.dataset.productPrice,
            sale              : element.dataset.productOnSale,
            comparePrice      : element.dataset.productComparePrice,
        }
    }

    /* WISHLIST AREA */

    updateAddToWishlistInput() {
        const newElement = document.createElement("wishlist-button");
        newElement.classList.add("smartwishlist");
        newElement.setAttribute('data-product', this.productJson.id);
        newElement.setAttribute('data-variant', this.productJson.variants[0].id);

        while(this.wishlistInput.firstChild){
            this.wishlistInput.removeChild(this.wishlistInput.firstChild);
        }
        this.wishlistInput.append(newElement);

        if (typeof ReloadSmartWishlist !== "undefined" && $.isFunction(ReloadSmartWishlist)){
            ReloadSmartWishlist();
        }
    }

    /* END WISHLIST AREA */
}
if (!customElements.get('product-card')) {
    customElements.define('product-card', ProductCard);
}

class EnjpAccordion extends HTMLElement {
    constructor() {
        super()
        this.el = this.querySelector('details');
        this.summary = this.el.querySelector('summary');
        this.content = this.el.querySelector('.content');
        this.animation = null;
        this.isClosing = false;
        this.isExpanding = false;
        this.summary.addEventListener('click', (e) => this.onClick(e));
    }

    onClick(e) {
        e.preventDefault();
        this.el.style.overflow = 'hidden';
        if (this.isClosing || !this.el.open) {
            this.handleOpen();
        } else if (this.isExpanding || this.el.open) {
            this.shrink();
        }
    }

    shrink() {
        this.isClosing = true;

        const startHeight = `${this.el.offsetHeight}px`;
        const endHeight = `${this.summary.offsetHeight}px`;

        if (this.animation) {
            this.animation.cancel();
        }

        // Start a WAAPI animation
        this.animation = this.el.animate({
            height: [startHeight, endHeight]
        }, {
            duration: 200,
            easing: 'ease-out'
        });

        this.animation.onfinish = () => this.onAnimationFinish(false);
        this.animation.oncancel = () => this.isClosing = false;
    }

    handleOpen() {
        this.el.style.height = `${this.el.offsetHeight}px`;
        this.el.open = true;
        window.requestAnimationFrame(() => this.expand());
    }

    expand() {
        this.isExpanding = true;
        const startHeight = `${this.el.offsetHeight}px`;
        const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

        if (this.animation) {
            this.animation.cancel();
        }

        // Start a WAAPI animation
        this.animation = this.el.animate({
            height: [startHeight, endHeight]
        }, {
            duration: 200,
            easing: 'ease-out'
        });
        this.animation.onfinish = () => this.onAnimationFinish(true);
        this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
        this.el.open = open;
        this.animation = null;
        this.isClosing = false;
        this.isExpanding = false;
        this.el.style.height = this.el.style.overflow = '';
    }
}


customElements.define('enjp-accordion', EnjpAccordion);

class BuyButtons extends HTMLElement {
    constructor() {
        super();
        this.form = this.querySelector('form[data-type="add-to-cart-form"]');
        this.expressCheckout = this.querySelector('#express-checkout');
        this.selectSizeLabel = document.querySelector('[data-select-size]');
        this.selectSizeErrorLabel = document.querySelector('[data-select-size-error]');
        this.variantIdInput = this.form?.querySelector('input[name="id"]');
    }

    connectedCallback() {
        if (!this.form) return;

        this.expressCheckout.addEventListener('click', async (event) => {
            event.preventDefault();
            if (!this.variantIdInput?.value) {
                this.selectSizeLabel.classList.add('tw-hidden');
                this.selectSizeErrorLabel.classList.remove('tw-hidden');
            } else {
                const formData = new FormData(this.form);
                try {
                    // Add to cart silently
                    this.querySelector('[data-express-checkout-label]').classList.add('tw-hidden');
                    this.querySelector('.express-spinner').classList.remove('hidden');
                    await fetch('/cart/add.js', {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json'
                        },
                        body: formData
                    });

                    // Redirect to checkout
                    window.location.href = '/checkout';
                } catch (error) {
                    console.error('Errore durante l’aggiunta al carrello:', error);
                    alert('C’è stato un problema con il checkout. Riprova.');
                }
            }
        });
    }
}

customElements.define('buy-buttons', BuyButtons);

// SUB EVENT TO SUBSCRIBE CUSTOMER TO NEWSLETTER

subscribe(PUB_SUB_EVENTS.registerNewsletter, async (data) => {
    try {
        const formData = {
            _mn_visible_contents: [1517, 4095, 1508, 1509, 1510, 1511, 1512, 1515],
            __mn_form_tpk65: "true",
            refererFormPage: "65",
            _mn_var: "0",
            _mn_spd: "0",
            _mn_idmsg: "0",

            email: data.email || "",
            nome: data.nome || "",
            cognome: data.cognome || "",
            datanascita: data.datanascita || "",
            nazione: data.nazione || "",

            policynl: "true",
            policynl_checkbox_present: "true",
            submitnl: "submit",

            _mn_refpageparams_65: JSON.stringify({
                values: {
                    __mn_form_tpk65: "true",
                    _mn_idmsg: "0",
                    _mn_spd: "0",
                    _mn_var: "0",
                    _mn_visible_contents: [1512, 1511, 1510, 1509, 1508, 4095, 1517, 1515],
                    cognome: data.cognome || "",
                    datanascita: data.datanascita || "",
                    email: data.email || "",
                    nome: data.nome || "",
                    nazione: data.nazione || "",
                    policynl_checkbox_present: "true",
                    refererFormPage: "65",
                    sl: "wp",
                    sl_: "ita",
                    submitnl: "submit",
                    sw: "21",
                    wp: "21",
                },
            }),
        };

        const response = await fetch(
            "https://liujoshoes.magnews.net/nl/web?h=k7advj7f2cqq0j2kv07ckfk2v&i=1ig&iw=3&p=H559540974&s=wp&sl=%3F&sw=21&wp=21",
            {
                method: "POST",
                headers: { "Content-Type": "application/x-www-form-urlencoded" },
                body: new URLSearchParams(formData),
            }
        );

        const text = await response.text();

        if (response.ok && response.status === 200) {
            console.log("Customer registered! response:", text);
        } else {
            console.error("ERROR! Status:", response.status, "Response:", text);
        }
    } catch (error) {
        console.error("Errore fetch:", error);
    }
});
